function groupByPatient(rows) {
  const order = []; const byId = new Map();
  for (const r of (rows || [])) {
    const eid = r.patient && r.patient.elationId;
    const key = String(eid);
    if (!byId.has(key)) {
      byId.set(key, { elationId: eid, name: (r.patient && r.patient.name) || 'Unknown', directoryId: r.patient && r.patient.directoryId, provider: r.provider || null, drafts: [], toExpand: 0, protectedCount: 0 });
      order.push(key);
    }
    const g = byId.get(key);
    g.drafts.push(r);
    if (r.classification && r.classification.expandable) g.toExpand += 1; else g.protectedCount += 1;
  }
  return order.map(k => byId.get(k));
}

function flowReducer(state, action) {
  switch (action.type) {
    // Pre-expand compose step (between inbox and loading). Establishes the
    // patient/draft/model identity that downstream modals read (loading/review
    // inherit it via ...state), and clears any prior expansion/error.
    case 'compose': return { ...state, flow: 'compose', activeDraftId: action.draftId, patientName: action.patientName, patientElationId: action.patientElationId, model: action.model, error: '', expansion: null, result: null };
    case 'expand': return { ...state, flow: 'loading', activeDraftId: action.draftId, error: '', expansion: null, result: null };
    case 'review': return { ...state, flow: 'review', expansion: action.expansion };
    case 'expandError': return { ...state, flow: 'inbox', error: action.message, activeDraftId: null };
    // A thrown commit (500/network) returns to the REVIEW gate — NOT inbox — so
    // the user's edited narrative (held in the page's useState) stays reachable
    // and they can retry Approve. Keeps draft/patient identity + expansion intact.
    case 'writeError': return { ...state, flow: 'review', error: action.message };
    case 'approve': return { ...state, flow: 'writing', error: '' };
    case 'written': return { ...state, flow: 'done', result: action.result };
    case 'reset': return { ...state, flow: 'inbox', activeDraftId: null, expansion: null, result: null, error: '' };
    default: return state;
  }
}

module.exports = { groupByPatient, flowReducer };
